import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';

import FreeSpinsExpired from '../../components/FreeSpins/Expired/Expired';
import { ActionType } from '../../enums';

import {
  TXTCLI_CongratulationsX_you_have_Free_ELL,
  TXTCLI_OK
} from './FreeSpins.Expired.messages.json';

export default {
  front: {
    view: FreeSpinsExpired,
    viewConfig: {
      title: { tag: TXTCLI_CongratulationsX_you_have_Free_ELL },
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_OK },
          actionFunction: ({ notificationId }: ActionParams) => {
            dispatch.notification.delete({ notificationId });
            dispatch.modal.close('/mpnotifications');
          }
        }
      ]
    }
  }
};
